import store from 'store'
import logout from 'utils/Client/authentication.js'
import actions from 'actions/index'

const { openModal } = actions

const RENEW_SESSION_TIMEOUT_MINUTES = 13
const EXPIRE_SESSION_TIMEOUT_MINUTES = 15
const MINUTE_IN_MILLISECONDS = 60000

class SessionHandler {

  constructor () {
    this.sessionEnabled = false
    this.sessionCheckedAt = null
    this.sessionTimeout = null
    this.logoutTimeout = null
  }

  initSession () {
    this.clearSessionTimers()
    this.handleSessionInit()
  }

  handleSessionInit () {
    this.sessionEnabled = true
    this.sessionCheckedAt = new Date().getTime()
    this.resetSessionTimeout()
  }

  resetSessionTimeout () {
    if (this.checkSleep()) {
      this.clearSessionTimers()
      if (this.sessionEnabled) {
        this.sessionTimeout = setTimeout(() => {
          this.askToRenewSession()
        }, MINUTE_IN_MILLISECONDS * RENEW_SESSION_TIMEOUT_MINUTES)
      }
    } else {
      this.expireSession()
    }
  }

  clearSessionTimers () {
    clearTimeout(this.sessionTimeout)
    clearTimeout(this.logoutTimeout)
  }

  disableSession () {
    this.sessionEnabled = false
    this.sessionCheckedAt = null
    this.clearSessionTimers()
  }

  expireSession () {
    this.disableSession()
    logout()
  }
  
  checkSleep () {
    // Make sure it's been less than 15 minutes since the last check (in case 
    // device goes to sleep, JS gets delayed)
    const now = new Date().getTime()
    const diff = now - this.sessionCheckedAt
  
    return !(diff > (MINUTE_IN_MILLISECONDS * EXPIRE_SESSION_TIMEOUT_MINUTES))
  }
  
  askToRenewSession () {
    clearTimeout(this.logoutTimeout)
    store.dispatch(openModal('timeoutModal'))

    this.logoutTimeout = setTimeout(() => {
      this.expireSession()
    }, MINUTE_IN_MILLISECONDS * (EXPIRE_SESSION_TIMEOUT_MINUTES - RENEW_SESSION_TIMEOUT_MINUTES))
  }

  renewSession () {
    if (this.sessionEnabled) {
      clearTimeout(this.logoutTimeout)
      if (this.checkSleep()) {       
        this.sessionCheckedAt = new Date().getTime()
        this.resetSessionTimeout()
      } else {
        this.expireSession()
      }
    }
  }

}

export default SessionHandler



// WEBPACK FOOTER //
// ./src/utils/Client/SessionHandler.js